'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var RightArrowCircled = function RightArrowCircled(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 12 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 12 : _ref$width;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-video-camera ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 12 12' },
    _react2.default.createElement(
      'g',
      { fillRule: 'evenodd' },
      _react2.default.createElement('circle', { cx: '6', cy: '6', r: '6', fill: color }),
      _react2.default.createElement('path', { fill: '#FFF', d: 'M6,7 L3,7 L3,5 L6,5 L6,3.15917967 C6,3.01732459 6.159,2.94747172 6.252,3.04741507 L8.896,5.88774058 C8.953,5.95007084 8.953,6.05001419 8.896,6.11234445 L6.252,8.95374462 C6.159,9.05261331 6,8.98276043 6,8.84090535 L6,7 Z' })
    )
  );
};

RightArrowCircled.propTypes = _bcPropTypes.iconShape;

exports.default = RightArrowCircled;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/RightArrowCircled/RightArrowCircled.js
// module id = 1277
// module chunks = 1